import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SkillReviewProgressCredit {
  id: number;
  title: string;
  description: string;
  type: string;
  evidence_progress_id: number;
  associated_level: number;
}

export interface SkillReviewSelectedArea {
  id: number;
  title: string;
  position: number;
  description: string;
  credits: SkillReviewProgressCredit[];
};

export type SkillSelectionDisplayInfo = {
  [key: number]: {
    isSelected: boolean;
    wasSelectedByAI: boolean;
  }
};

export type SelectedAreasById = { [key: number]: SkillReviewSelectedArea }

export type SubskillScores = { [key: string]: number};


// State for the selections made in the skill review page of the AI Helper tool.
export interface AIHelperProgress {
  skillsReview: {
    selectedAreasById: SelectedAreasById;
    finalSkillSelections: SkillReviewSelectedArea[]; // the list of areas with evidence_progress_id included in the credits, used for sending in the request body when user clicks next on skills review page.
    selectedAreasDisplayInfo: SkillSelectionDisplayInfo;
  } | null;
  subskillsReview: {
    // the list of areas after filtering out areas that have no subskill levels after subskill review.
    selectedAreasWithScoredCredits: SkillReviewSelectedArea[];
    subskillScores: SubskillScores;
  } | null;
  shareFeedback: {
    summary: string;
  } | null;
}

// a credit with the evidence_progress_id field mixed in.

export interface AIHelperProgressState {
  data: AIHelperProgress;
}

const initialState: AIHelperProgressState = {
  data: {
    skillsReview: null,
    subskillsReview: null,
    shareFeedback: null
  },
};

const aiHelperProgressSlice = createSlice({
  name: "skillReviewProgress",
  initialState,
  reducers: {
    setAIHelperProgressRedux(state, action: PayloadAction<AIHelperProgress>) {
      state.data = action.payload;
    },
    clearAIHelperProgressRedux(state) {
      state.data = initialState.data;
    },
  },
});

export const { setAIHelperProgressRedux, clearAIHelperProgressRedux } = aiHelperProgressSlice.actions;
export default aiHelperProgressSlice.reducer;
